import React, { useState } from 'react';
import { QuantityPicker } from 'react-qty-picker';
import { useDispatch } from 'react-redux';
import { format } from 'date-fns';

import {
  commerceProductChangeQuantity,
} from '@uncinc/react-drupal-core/dist/redux/actions/Commerce';

import CartProductImage from './CartProductImage';
import './style.scss';
import RemoveProductModal from '../RemoveProductModal';

const CartProduct = ({ title, type, price, quantity, maximumQuantity, id, image, body = null, date = null, location = null, readOnly }) => {
  const dispatch = useDispatch();
  const [showModal, setShowModal] = useState(false);
  const isTraining = !!type.includes('fysieke-training');
  const minimumQuantity = 1;

  return (
    <div className="CartProduct">
      <div className="CartProduct__image">
        <CartProductImage image={image} />
      </div>
      <div className="CartProduct__details">
        <div className="CartProduct__details__row">
          <div className="CartProduct__details__title">{title}</div>
          {readOnly && <div><strong>{quantity}x</strong></div>}
          <div className={readOnly && 'readOnly'}><strong>{price}</strong></div>

          {!readOnly && <div onClick={() => setShowModal(true)} className="icon icon-cross" />}
        </div>
        {(body || location || date) && (
          <div className="CartProduct__details__row">
            <div>
              { body && <div className="CartProduct__details__body">{body}</div> }
              { location && <div className="CartProduct__details__location">{location}</div> }
              { date && <div className="CartProduct__details__date">{format(new Date(date), 'dd-MM-YY HH:mm')}</div> }
            </div>
          </div>
        )}

        <div className="CartProduct__details__row">
          {!readOnly && !isTraining && (
            <div className="CartProduct__details__quantity">
              <QuantityPicker
                min={minimumQuantity}
                max={maximumQuantity || 10}
                value={quantity}
                onChange={(value) => dispatch(commerceProductChangeQuantity(id, value))}
                width="2.6rem"
              />
            </div>
          )}
        </div>
      </div>
      {showModal && <RemoveProductModal showModal={showModal} id={id} setShowModal={setShowModal} />}
    </div>
  );
};

export default CartProduct;
